var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobDepart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27,
    rx: 13.5,
    fill: "#F9FAFB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27,
    rx: 13.5,
    stroke: "#EAECF0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3164_57547)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.66659 18V17.8667C8.66659 16.7466 8.66659 16.1865 8.88457 15.7587C9.07632 15.3824 9.38228 15.0764 9.7586 14.8847C10.1864 14.6667 10.7465 14.6667 11.8666 14.6667H16.1333C17.2534 14.6667 17.8134 14.6667 18.2412 14.8847C18.6176 15.0764 18.9235 15.3824 19.1153 15.7587C19.3333 16.1865 19.3333 16.7466 19.3333 17.8667V18M8.66659 18C7.93021 18 7.33325 18.597 7.33325 19.3334C7.33325 20.0698 7.93021 20.6667 8.66659 20.6667C9.40297 20.6667 9.99992 20.0698 9.99992 19.3334C9.99992 18.597 9.40297 18 8.66659 18ZM19.3333 18C18.5969 18 17.9999 18.597 17.9999 19.3334C17.9999 20.0698 18.5969 20.6667 19.3333 20.6667C20.0696 20.6667 20.6666 20.0698 20.6666 19.3334C20.6666 18.597 20.0696 18 19.3333 18ZM13.9999 18C13.2635 18 12.6666 18.597 12.6666 19.3334C12.6666 20.0698 13.2635 20.6667 13.9999 20.6667C14.7363 20.6667 15.3333 20.0698 15.3333 19.3334C15.3333 18.597 14.7363 18 13.9999 18ZM13.9999 18V11.3334M9.99992 11.3334H17.9999C18.6212 11.3334 18.9318 11.3334 19.1768 11.2319C19.5035 11.0966 19.7631 10.837 19.8984 10.5103C19.9999 10.2653 19.9999 9.95463 19.9999 9.33337C19.9999 8.71212 19.9999 8.40149 19.8984 8.15646C19.7631 7.82976 19.5035 7.57019 19.1768 7.43487C18.9318 7.33337 18.6212 7.33337 17.9999 7.33337H9.99992C9.37866 7.33337 9.06804 7.33337 8.82301 7.43487C8.4963 7.57019 8.23674 7.82976 8.10141 8.15646C7.99992 8.40149 7.99992 8.71212 7.99992 9.33337C7.99992 9.95463 7.99992 10.2653 8.10141 10.5103C8.23674 10.837 8.4963 11.0966 8.82301 11.2319C9.06804 11.3334 9.37866 11.3334 9.99992 11.3334Z",
    stroke: "#667085",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3164_57547"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobDepart);
export default __webpack_public_path__ + "static/media/job-depart.652e4699ceaab77d868d7e84738dbd55.svg";
export { ForwardRef as ReactComponent };